import React from 'react'
import Helmet from 'react-helmet'
import styled, { withComponent } from 'react-emotion'
import { space } from 'styled-system'
import Link from 'gatsby-link'
import format from 'date-fns/format'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/fontawesome-free-solid'

import {
  InstantSearch,
  Hits,
  SearchBox,
  Highlight,
  RefinementList,
  Pagination,
  CurrentRefinements,
  ClearRefinements,
  PoweredBy,
  Stats,
} from 'react-instantsearch/dom'
import 'instantsearch.css/themes/algolia.css'

import { Box, Text } from '../components/Layout'
import { Title, Subtitle, Paragraph, Rule } from '../components/Typography'

const SearchLinkStyle = ({ children }) => (
  <Text color="black" hover={{ color: 'orange' }}>
    {children}
  </Text>
)

const Note = ({ hit }) => {
  return (
    <div style={{ marginTop: '10px' }}>
      <FontAwesomeIcon icon={faChevronRight} />
      &nbsp;
      <Link to={hit.slug}>
        <SearchLinkStyle>
          <span className="hit-name">
            <Highlight attribute="title" hit={hit} />
          </span>
        </SearchLinkStyle>
      </Link>
      &nbsp;&mdash;&nbsp;
      <time dateTime={hit.date}>{format(hit.date, 'DD. MMMM YYYY')}</time>
    </div>
  )
}

const SearchContainer = styled.div`
  .ais-PoweredBy, .ais-Stats-text {
    color: ${({ theme }) => theme.colors.black};
  },
  .ais-SearchBox-input {
    border: 0px;
    color: ${({ theme }) => theme.colors.black};
    caret-color: ${({ theme }) => theme.colors.orange};
    border-radius: 0px;
    line-height: ${({ theme }) => theme.lineHeights['title']};
    font-weight: ${({ theme }) => theme.fontWeights[7]};
    font-size: 3.0rem;
    outline: none;
    padding: 0.3rem 0rem;
  },
  .ais-SearchBox-submit {
    display: none;
  },
  .ais-SearchBox-input::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.black};
  },
  .ais-SearchBox-input::-moz-placeholder {
    color: ${({ theme }) => theme.colors.black};
  },
  .ais-SearchBox-input:-ms-input-placeholder {
    color: ${({ theme }) => theme.colors.black};
  },
  .ais-SearchBox-input:-moz-placeholder {
    color: ${({ theme }) => theme.colors.black};
  },
  .ais-Hits {
    margin-top: 2rem;
  },
  .ais-Hits-item, .ais-InfiniteHits-item, .ais-InfiniteResults-item, .ais-Results-item {
    margin-top: 0rem;
    margin-left: 0rem;
    border: none;
    box-shadow: none;
    padding-top: 0rem;
    padding-bottom: 0rem;
    width: 100%;
    color: ${({ theme }) => theme.colors.black};
    line-height: ${({ theme }) => theme.lineHeights['copy']};
    font-weight: ${({ theme }) => theme.fontWeights['normal']};
    font-size: ${({ theme }) => theme.fontSizes[1]};

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
      font-size: ${({ theme }) => theme.fontSizes[2]};
    }
  },
  .ais-Highlight, .ais-Highlight-highlighted, .ais-Highlight-nonHighlighted {
    line-height: ${({ theme }) => theme.lineHeights['copy']};
    font-weight: ${({ theme }) => theme.fontWeights['normal']};
    font-size: ${({ theme }) => theme.fontSizes[1]};

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
      font-size: ${({ theme }) => theme.fontSizes[2]};
    }
  }
  .ais-Highlight-highlighted, .ais-Snippet-highlighted {
    color: ${({ theme }) => theme.colors.orange};
    background-color: ${({ theme }) => theme.colors.white};
  },
  .ais-Pagination-link {
      display: block;
      border: none;
      border-radius: 0;
      transition: background-color .2s ease-out;
  },
  a {
    .ais-Pagination-link {
      color: ${({ theme }) => theme.colors.black};
    },
  },
  a {
    .ais-Pagination-link:hover {
      color: ${({ theme }) => theme.colors.white};
      background-color: ${({ theme }) => theme.colors.orange};
    },
  },
  a {
    .ais-Pagination-item--disabled .ais-Pagination-link {
      cursor: not-allowed;
      color: ${({ theme }) => theme.colors.black};
    },
  },
  a {
    .ais-Pagination-item--selected .ais-Pagination-link {
      color: ${({ theme }) => theme.colors.white};
      background-color: ${({ theme }) => theme.colors.orange};
    },
  },
`

const SearchPage = ({ data }) => {
  return (
    <article>
      <Helmet>
        <title>Search • {data.site.siteMetadata.title}</title>
      </Helmet>
      <SearchContainer>
        <InstantSearch
          appId={data.site.siteMetadata.algolia.appId}
          apiKey={data.site.siteMetadata.algolia.searchApiKey}
          indexName={data.site.siteMetadata.algolia.indexName}
        >
          <header>
            <SearchBox
              autoFocus="true"
              autoComplete="on"
              autoCorrect="on"
              translations={{ placeholder: 'Search' }}
            />
            <PoweredBy />
            <Stats translations={{ stats: (n, ms) => '' + n + ' Notes' }} />
            <Rule mt={3} mb={5} />
          </header>
          <main>
            <Hits hitComponent={Note} />
            <Pagination />
          </main>
        </InstantSearch>
      </SearchContainer>
    </article>
  )
}

export const pageQuery = graphql`
  query SearchQuery {
    site {
      siteMetadata {
        title
        algolia {
          appId
          searchApiKey
          indexName
        }
      }
    }
  }
`

export default SearchPage



// WEBPACK FOOTER //
// ./src/pages/search.js